import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _define_property from "@swc/helpers/src/_define_property.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import invariant from "tiny-invariant";
import { ChainId } from "../constants";
import { validateAndParseAddress } from "../utils";
import { Currency } from "./currency";
/**
 * Represents an ERC20 token with a unique address and some metadata.
 */ export var Token = /*#__PURE__*/ function(Currency) {
    "use strict";
    _inherits(Token, Currency);
    var _super = _create_super(Token);
    function Token(chainId, address, decimals, symbol, name, projectLink) {
        _class_call_check(this, Token);
        var _this;
        _this = _super.call(this, decimals, symbol, name);
        _this.chainId = chainId;
        _this.address = validateAndParseAddress(address);
        _this.projectLink = projectLink;
        return _this;
    }
    var _proto = Token.prototype;
    /**
   * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
   * @param other other token to compare
   */ _proto.equals = function equals(other) {
        // short circuit on reference equality
        if (this === other) {
            return true;
        }
        return this.chainId === other.chainId && this.address === other.address;
    };
    /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   */ _proto.sortsBefore = function sortsBefore(other) {
        invariant(this.chainId === other.chainId, "CHAIN_IDS");
        invariant(this.address !== other.address, "ADDRESSES");
        return this.address.toLowerCase() < other.address.toLowerCase();
    };
    return Token;
}(Currency);
/**
 * Compares two currencies for equality
 */ export function currencyEquals(currencyA, currencyB) {
    if (_instanceof(currencyA, Token) && _instanceof(currencyB, Token)) {
        return currencyA.equals(currencyB);
    } else if (_instanceof(currencyA, Token)) {
        return false;
    } else if (_instanceof(currencyB, Token)) {
        return false;
    } else {
        return currencyA === currencyB;
    }
}
var _obj;
export var WETH = (_obj = {}, _define_property(_obj, ChainId.BSC, new Token(ChainId.BSC, "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", 18, "WETH", "Wrapped ETH", "https://stealthswap.trade")), _define_property(_obj, ChainId.BSC_TESTNET, new Token(ChainId.BSC_TESTNET, "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd", 18, "WETH", "Wrapped ETH", "https://stealthswap.trade")), _obj);
var _obj1;
export var WNATIVE = (_obj1 = {}, _define_property(_obj1, ChainId.BSC, WETH[ChainId.BSC]), // [ChainId.ETH]: WETH[ChainId.ETH],
// [ChainId.ARB]: WETH[ChainId.ARB],
// [ChainId.BASE]: WETH[ChainId.BASE],
// [ChainId.POLYGON]: WETH[ChainId.POLYGON],
_define_property(_obj1, ChainId.BSC_TESTNET, WETH[ChainId.BSC_TESTNET]), _obj1);
